<template>
    <div>

        <div style="margin-left:50px;">
            <el-form style="display: flex;flex-wrap: wrap;">

                <el-form-item label="学生姓名:" style="display: flex;width: 33%; margin-left: -14px;" >
                    <el-select  placeholder="请选择学生姓名"  v-model="student_s"  style="width: 100%" clearable  filterable>
                        <el-option  v-for="item in getStudentsArr_s" :key=" item.id + 'student_s' "  :value="item.id"  :label="item.realname"   >  </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="学科:" style="display: flex;width: 33%;" >
                    <el-select  placeholder="请选择学科" v-model="coursecancellationStatusInput"  style="width: 100%"  clearable  filterable >
                        <el-option  v-for="item in coursecancellationStatus" :key=" item.id + 'coursecancellationStatusInput' " :value="item.id"  :label="item.realname"  >  </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="排课节数:" style="display: flex;width: 33%;" >
                    <el-input v-model="input1" placeholder="请输入排课节数"></el-input>
                </el-form-item>

                <el-form-item label="路程距离设置:" style="display: flex;width: 32%;" >
                    <el-input v-model="input2" placeholder="请输入路程距离设置"></el-input>
                </el-form-item>
                
                <el-form-item label="必须为跟进老师:" style="display: flex;width: 33%;" >
                    <el-select  placeholder="请选择必须为跟进老师"   v-model="itme1"  style="width: 100%"  clearable   filterable >   
                        <el-option   v-for="(item,index) in itme1List"  :key=" item.id +  index + 'itme1' "  :value="item.id"   :label="item.realname"   >  </el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="是否指定老师:" style="display: flex;width: 35%;" >
                    <el-select  placeholder="请选择是否指定老师" v-model="itme2"  style="width: 100%"  clearable  filterable > 
                         <el-option  v-for="item  in itme2List"  :key=" item.id"  :value="item.id"  :label="item.realname"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="老师是否当天排5次课:" style="display: flex;width: 40%;" >
                    <el-select   placeholder="请选择老师是否当天排5次课"  v-model="itme3"  style="width: 100%"  clearable  filterable >
                        <el-option  v-for="(item,index)  in itme3List"  :key=" item.id + item.realname + index +'itme3' "  :value="item.id"  :label="item.realname"  >  </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="班型:" style="display: flex;width: 35%;" >
                    <el-select  placeholder="请选择班型" v-model="itme2"  style="width: 100%"  clearable  filterable > 
                         <el-option  v-for="item  in itme2List"  :key=" item.id"  :value="item.id"  :label="item.realname"></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="可用日期:" style="display: flex;width: 53%;" >
                    <el-date-picker  v-model="input3"  type="daterange" value-format="yyyy-MM-dd"  range-separator="至" start-placeholder="开始日期"   end-placeholder="结束日期" ></el-date-picker>
                </el-form-item>



                <el-form-item  style="display: flex;width: 100%;" v-if="input3" >
                   <div style="display: flex;">可用时间段:</div>
                   <div style="display: flex;flex-wrap: wrap;">
                        <el-time-picker style=" margin-top: 10px;margin-right: 100px;" v-for="(item,index) in timeValueList"  :key="index" is-range  arrow-control  v-model="item.timeValue"  range-separator="至"  start-placeholder="开始时间"  end-placeholder="结束时间"  placeholder="选择可用时间段"></el-time-picker>
                        <div style="margin-left:20px;margin-top:15px;">
                            <div style="font-size: 26px;padding-top: 1px; display: flex;">
                                <i class="el-icon-circle-plus-outline" @click="handleMultipleChoiceQuestionAdd('add')"></i>
                                <i v-if="timeValueList.length > 1" class="el-icon-remove-outline" @click="handleMultipleChoiceQuestionAdd"></i>
                            </div>
                        </div>  
                   </div>
                </el-form-item>



                <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-message-solid" @click="addBtns">一键排课</el-button>
                </div>

            </el-form>
        </div>


        <div class="demo-app">
            <div class="demo-app-main">
                <FullCalendar  ref="fullCalendar"  class="demo-app-calendar"  :options="calendarOptions"  >
                    <template v-slot:eventContent="arg">
                    <b>{{ arg.timeText }}</b>
                    <span>{{ arg.event.title }}</span>
                    </template>
                </FullCalendar>
            </div>
        </div>



    </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import zhcn from "@fullcalendar/core/locales/zh-cn";

export default {
    components: {
        FullCalendar,
    },
    data() {
        return {
            student_s:'',
            getStudentsArr_s :[{ id: 1, realname : '颇多野' },{ id: 2, realname : '梅川合' },{ id: 3, realname : '拖一大' }],
            coursecancellationStatusInput:'',
            coursecancellationStatus:[{ id: 1, realname : '颇多野' },{ id: 2, realname : '梅川合' },{ id: 3, realname : '拖一大' }],
            itme1List:[{ id: 1, realname : '是' }, { id: 2, realname : '否' }],
            itme1:'',
            itme2List:[{ id: 1, realname : '是' }, { id: 2, realname : '否' }],
            itme2:'',
            itme3List:[{ id: 1, realname : '是' }, { id: 2, realname : '否' }],
            itme3:'',
            input1:'',
            input2:'',
            input3:'',
            timeValueList:[{timeValue:''}],
            calendarOptions: {
                handleWindowResize: true,
                eventColor: this.getEventColor, // 使用方法来确定颜色
                firstDay: 1,
                allDaySlot: false, // 不显示all-day
                firstHour: 6,
                slotMinTime: "06:00:00",
                slotMaxTime: "24:00:00",
                plugins: [
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin, // needed for dateClick
                ],
                datesSet: this.handleDatesSet,
                headerToolbar: {
                left: "prev,next today",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay",
                },

                /* 设置按钮文字 */
                buttonText: {
                today: "今天",
                dayGridMonth: "月",
                timeGridWeek: "周",
                timeGridDay: "日",
                },
                locale: "zh-cn",
                // dayGridMonth, timeGridWeek,timeGridDay
                initialView: "dayGridMonth",
                // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
                editable: true,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                // handleViewRender,
                eventDidMount: function (info) {
                    if (info.event.extendedProps.isShowbgcColor) {  info.el.style.background = "darkgray" } 
                    else {  info.el.style.background = "#3788d8" }
                    if ( info.event.extendedProps.classEnding == 1 &&  info.event.extendedProps.isFirst !== 1 ) {
                         info.el.style.background = "orange"
                         info.el.style.borderColor = "orange"
                    }
                    if ( info.event.extendedProps.isFirst == 1 &&info.event.extendedProps.classEnding == 1) {
                         info.el.style.background = "#E380E3";
                         info.el.style.borderColor = "#E380E3";
                    }
                    if (info.event.extendedProps.isFirst == 1 &&info.event.extendedProps.classEnding !== 1) {
                         info.el.style.background = "#54bcbd";
                         info.el.style.borderColor = "#54bcbd";
                    }
                },
                events: [],
                customButtons: {
                next: {
                    click: this.nextClick,
                },
                prev: {
                    click: this.prevClick,
                },
                },
                eventColor: function (event) {
                if (event.start.isBefore(new Date())) {
                    return "f0f0f0"; // 过去事件的背景颜色
                } else {
                    return "#008000"; // 未来事件的背景颜色
                }
                },

                // select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                /* you can update a remote database when these fire:
                eventAdd:
                eventChange:
                eventRemove:
                */
            },
        }
    },

    mounted() {
       
    },
    

    methods:{   
        // 查询指定教师列表
        getPreTeacherList(){
            axios
            .post(`${apiBaseUrl}/preScheduled/getPreTeacherLis`, {
                isFollowUp: 1,
                studentId:'',
                subjectIds:'',
                classType:''
            },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                }
                })
            .then((res) => {
                let { data } = res;
                if (data.code == 200) {
                this.studentsList = data.data
                sessionStorage.setItem(
                    "getStudentList_Jons",
                    JSON.stringify(data.data)
                );
                }
            });

        },

        
      

        clearBtns(){
            this.student_s = ''
            this.coursecancellationStatusInput = ''
            this.itme1 = ''
            this.itme2 = ''
            this.itme3 = ''
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.timeValueList = [{timeValue:''}]
        },

        searchBtns(){

        },
        

        addBtns(){
        axios
            .post(`${apiBaseUrl}/preScheduled/teachingSchedule`, {
                isFollowUp: 1,
                studentId:'',
                subjectIds:'',
                travelTime:'',
                availableDates:'',
                availableTimes:'',
                isDesignatedTea:'',
                isFiveIeaInDate:''
            },{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                }
                })
            .then((res) => {
                console.log('res: ', res);
                let { data } = res;
                if (data.code == 200) {
                    console.log('data.code: ', data.code);   
               
                }
            });


        },

        handleMultipleChoiceQuestionAdd(value){
            if(value === 'add'){
                this.timeValueList.push({ timeValue:'' })
            }else{
                this.timeValueList.pop()
            }
        },

        deleteByIndex(arr, index){
           arr.splice(index, 1)
           return arr
        },

        
        handleEventClick(clickInfo) {
            this.btnInitialViewSelect = clickInfo.view.type
            this.courses.categoryName = clickInfo.event._def.title
            this.categoryId = clickInfo.event._def.publicId
            this.scheduleId = clickInfo.event._def.extendedProps.scheduleId
            this.courses.date = clickInfo.event.startStr
            this.id1 = clickInfo.event.id

            if (clickInfo.event.startStr.length >= 10) {
                this.ruleForm.startTime = clickInfo.event.startStr.substr(11, 16).substr(0, 5)
            } else {
                this.diagnosisOff.startTimeHour = ""
                this.diagnosisOff.endTimeHour = ""
            }

            if (typeof this.scheduleId !== "undefined") {
                const scheduleId = clickInfo.event._def.extendedProps.scheduleId
                this.showNewSchedule(scheduleId)
            } else {
                const scheduleId = clickInfo.event._def.extendedProps.scheduleId
            
                this.dialogVisible = true;
            }

            this.getAllStudents()
        },


        handleEvents(events) {
            let index = events.length;
            let eventStop = events[index - 1]
            this.currentEvents = events
        },


        nextClick() {
            this.jsonShow = false
            let calendarApi = this.$refs["fullCalendar"].getApi()
            calendarApi.next()
            this.startTime1 = this.aa(calendarApi.view.activeStart)
            this.endTime1 = this.aa(calendarApi.view.activeEnd)
            let dateFormat = new Date(this.endTime1)
            dateFormat = dateFormat.setDate(dateFormat.getDate() - 1)
            dateFormat = new Date(dateFormat)
            let y = dateFormat.getFullYear()
            let m = (dateFormat.getMonth() + 1).toString().padStart(2, "0")
            let d = dateFormat.getDate().toString().padStart(2, "0")
            this.endTime1 = y + "-" + m + "-" + d
            this.listdate(1)
        },


        prevClick() {
            this.jsonShow = false
            let calendarApi = this.$refs["fullCalendar"].getApi()
            calendarApi.prev()
            this.startTime1 = this.handdleTimeS(calendarApi.view.activeStart)
            this.endTime1 = this.handdleTimeS(calendarApi.view.activeEnd)

            console.log(this.handdleTimeS(calendarApi.view.activeStart), "开始时间")
            console.log(this.handdleTimeS(calendarApi.view.activeEnd), "结束时间")

            let dateFormat = new Date(this.endTime1)
            dateFormat = dateFormat.setDate(dateFormat.getDate() - 1)
            dateFormat = new Date(dateFormat)
            let y = dateFormat.getFullYear()
            let m = (dateFormat.getMonth() + 1).toString().padStart(2, "0")
            let d = dateFormat.getDate().toString().padStart(2, "0")
            this.endTime1 = y + "-" + m + "-" + d
            this.listdate(0)
        },




        getListAssembly(response) {
            let b = []

            for (let i = 0; i < response.data.data.length; i++) {
                var aa = {  classEnding: response.data.data[i].classEnding, title: response.data.data[i].courseName,  scheduleId: response.data.data[i].scheduleId,  isFirst: response.data.data[i].isFirst,
                            start:  response.data.data[i].courseDate +  " " +  response.data.data[i].courseTimeOn,
                            end:  response.data.data[i].courseDate +  " " +  response.data.data[i].courseEndTime,  }
                var currentTime = new Date()
                var specifiedTime = new Date(aa.start)
                if (currentTime > specifiedTime) {
                    aa.color = "darkgray"
                    aa.isShowbgcColor = true
             } else {
                   aa.isShowbgcColor = false;
                }
                b.push(aa);
            }

            this.calendarOptions.events = b
            loadingUtils.endLoading()
            this.lockLoading = false
            this.loadingFalg = false
        },




        listdate() {
            loadingUtils.startLoading()
            this.lockLoading = true

            if (!this.startTime1 && !this.endTime1) {
                const now = new Date();
                const firstDay = new Date(now.getFullYear(), now.getMonth(), 1); 
                const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                this.startTime1 = this.formatConvert(
                new Date(
                    firstDay.getFullYear(),
                    firstDay.getMonth(),
                    firstDay.getDate() - 7
                )
                );
                this.endTime1 = this.formatConvert(
                new Date(
                    lastDay.getFullYear(),
                    lastDay.getMonth(),
                    lastDay.getDate() + 11
                )
                )
            } 
            else {
                let calendarApi = this.$refs["fullCalendar"].getApi();
                let str = calendarApi.view.title.replace("年", "");
                let result = str.replace("月", "");
                let sub = result.substring(4, 6);
                let ysub = result.substring(0, 4);
                let start = `${ysub}-${sub < 10 ? "0" + sub : sub}-01`;
                let end = `${ysub}-${sub < 10 ? "0" + sub : sub}-31`;

                axios.post(`${apiBaseUrl}/schedule/selectschedule`, {
                    teacher_id: this.selectedTeacher,
                    page: "",
                    limit: "",
                    start_time: calendarApi.currentData.currentViewType == "dayGridMonth"  ? start : this.startTime1,
                    end_time: calendarApi.currentData.currentViewType == "dayGridMonth" ? end  : this.endTime1,
                    student_id: this.listJsonString,
                },{ headers:{  'authorization': sessionStorage.getItem('tokenInfo') }
                }).then((response) => {
                    this.getListAssembly(response)
                }).catch((error) => {
                    this.lockLoading = false
                })
            }
        },





        handdleTimeS(date1) {
            let y = date1.getFullYear();
            let m = date1.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            let d = date1.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date1.getHours();
            h = h < 10 ? "0" + h : h;
            let M = date1.getMinutes();
            M = M < 10 ? "0" + M : M;
            let s = date1.getSeconds();
            s = s < 10 ? "0" + s : s;
            return y + "-" + m + "-" + d;
        },







    }


}
 

</script>


<style lang="less" scoped>

    .demo-app-calendar .fc-past-event {
       background-color: gray;
    }
    .demo-app-main {
        flex-grow: 1;
        padding: 3em 3em 0 1.5em;
    }
    .demo-app-calendar .fc-past-event {
       background-color: gray;
    }

    .btns {
        background-color: #428bca;
        border-color: #428bca;
        color: #fff;
    }

</style>


// WEBPACK FOOTER //
// src/IntelligentScheduling/IntelligentScheduling.vue